import React from "react";
import {Alert, Typography} from "@mui/material";
import {PersonDocumentType} from "arteco-api-client-ts";

/**
 * La descripción del tipo de documento, como aviso bajo el selector de tipo. La usan el admin y el
 * portal del empleado al subir un documento (#13997: el justificante de ausencia, sin diagnóstico).
 */
export const PersonDocumentTypeHint = ({type}: { type?: PersonDocumentType }) => {
	const text = type?.description?.trim();
	if (!text) return null;
	return (
		<Alert severity="info" icon={false} sx={{mb: 2, borderRadius: 2}}>
			<Typography variant="body2">{text}</Typography>
		</Alert>
	);
};
